import React from 'react';
import { Phone } from 'lucide-react';

/**
 * Persistent floating emergency-call CTA.
 * - Fixed bottom-right on every public page (hidden on /admin/* routes).
 * - Pulse-ring animation draws the eye without being obnoxious.
 * - Expands to show "EMERGENCY 24/7" label on sm+ screens; pure round icon on mobile.
 * - tel: link with international +44 format for reliable dialing.
 */
const EMERGENCY_NUMBER_DISPLAY = '020 8059 9941';
const EMERGENCY_NUMBER_TEL = '+442080599941';

const EmergencyCallButton = () => {
  return (
    <a
      href={`tel:${EMERGENCY_NUMBER_TEL}`}
      aria-label={`Emergency call out — ${EMERGENCY_NUMBER_DISPLAY}`}
      data-testid="floating-emergency-call-button"
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 group"
    >
      {/* Pulsing halo */}
      <span className="absolute inset-0 rounded-full bg-red-600 opacity-75 animate-ping" aria-hidden="true" />

      {/* Button body */}
      <span
        className="
          relative flex items-center justify-center gap-2
          bg-red-600 hover:bg-red-700 text-white
          rounded-full shadow-lg shadow-red-600/50
          w-14 h-14 sm:w-auto sm:h-auto sm:px-5 sm:py-3
          transition-all
        "
      >
        <Phone className="w-6 h-6 sm:w-5 sm:h-5 flex-shrink-0" strokeWidth={2.4} />
        <span className="hidden sm:flex flex-col leading-tight">
          <span className="text-[10px] font-bold tracking-wider uppercase opacity-90">Emergency 24/7</span>
          <span className="text-sm font-bold">{EMERGENCY_NUMBER_DISPLAY}</span>
        </span>
      </span>
    </a>
  );
};

export default EmergencyCallButton;
